import React from "react";
// import {Link} from 'react-router-dom';

import RubberBand from 'react-reveal/RubberBand';
// import Pulse from 'react-reveal/Pulse';

// import EarlyAccessForm from '../reuse/form/early_access';
// import Samples from '../reuse/samples';


export default class HeroSection extends React.Component {

  render (){
    const hero = {
      image: {
        path: '/static/images/hero.svg',
        alt: '"Simple notifications platform."',
      },
    }

    return (
      <section id="hero" className=" my-5">
        <HeroTitleSubFeaturesImageComponent hero={hero} />
      </section>
    )
  }
}

function HeroTitleSubFeaturesImageComponent(props){
  const hero = props.hero;
  const is_mobile = window.innerWidth < 1200;
  return (
    <div className="row my-5">

      {(is_mobile)? (
      <div className=" col-12  p-0 img img-fluid text-center align-self-center">
        <img className="hero" src={hero.image.path} alt={hero.image.alt} />
      </div> 
      ): ''}

      <div className=" col-md-6 align-self-center">

        <h1 className="text-left mt-5 p-2">
          <span className="text-black-2">Simple REST </span>
          <span className="text-primary"> notifications API</span>
          {/* <span className="text-black-2"> for developers</span> */}
        </h1>

        <div className="p-2 my-3">
          <p className="text-left pb-3 mb-5 ">
            Get notified through
            <span className="text-primary"> email, sms, chat and app notifications </span> 
            with a POST request!
          </p>
        </div>

        <div className={((is_mobile)? " my-1 ": " my-5 ")}>
          <div className={"container-fluid " + ((is_mobile)? " py-1 ": " py-5 ")}>
            <RubberBand>
              <div className="text-center">
                <a className="btn-quinary btn-lg text-white btn-rounded py-2 px-4 text-spacing-2 text-size-4 " href="https://lightflare-app.bytebeacon.com/">
                  Get started in {"<"} 5 mins
                  <i className="fas fa-paper-plane ml-2"></i>
                </a>
                <p className="text-muted my-2">* No credit card required</p>
                {/* <EarlyAccessForm full_width={true} /> */}
              </div>
            </RubberBand>
          </div>
        </div>

      </div> 

      <div className=" col-md-6 d-none d-md-block p-0 img img-fluid text-center align-self-center">
        <img className="hero" src={hero.image.path} alt={hero.image.alt} />
      </div> 

    </div>
  )
}
